module.exports = __webpack_public_path__ + "img/gsb19.aa5de006.png";